/**
 * 产品列表静态数据 JS
 * @Author 吴成林
 * @Date 2021-9-29 17:49:40
 */
export default {
  /* 1: 意外险，2：雇主责任险 */
  data: {
    1: {
      //-- 人保 - 人保财团体意外伤害保险
      '人保财团体意外伤害保险': {
        presentation: ['1-6类职业可保', '最高可投100万', '综合意外保障', '身故伤残、意外医疗、住院津贴可灵活配置'],
        picture: '../../static/images/product/ejSiNo/03.png',
        100421: {
          scheme: 'B款',
          price: '63',
          promotionExpenses: '21%',
        },
        100433: {
          scheme: 'C款',
          price: '74',
          promotionExpenses: '27%',
        }
      },
      //-- 阳光财 - 团体意外险2020特别升级版
      '阳光财团体意外险2020特别升级版': {
        presentation: ['1-5类职业可投保，最高承保保额80万', '承保高空作业', '扩展新型冠状病毒肺炎保障', '意外医疗免赔额和赔付比例可选择'],
        picture: '../../static/images/product/ejSiNo/02.png',
        100422: {
          scheme: 'A款',
          price: '50',
          promotionExpenses: '8%',
        },
        100430: {
          scheme: 'B款',
          price: '56',
          promotionExpenses: '17%',
        },
        100431: {
          scheme: 'C款',
          price: '65',
          promotionExpenses: '26%',
        },
        100432: {
          scheme: 'D款',
          price: '78',
          promotionExpenses: '34%',
        },
      },
      //-- 国寿财 - 团体意外保险
      '国寿财团体意外保险(已停售)': {
        presentation: ['承保1-5类职业', '1-2类职业5人起投', '3-5类职业10人起投', '参保人数超30人享保费折扣', '保险方案自由配置', '投保保全线上操作'],
        picture: '../../static/images/about/insurance-1.png',
        100414: {
          scheme: '',
          price: '36',
          promotionExpenses: '25%',
        },
      },
    },
    2: {
      //-- 上海平安 - 平安财雇主责任险2021版
      '平安财雇主责任险2021版': {
        presentation: ['承保高空作业', '支持扩展24小时意外保障', '支持扩展自费药', '意外医疗免赔额和赔付比例可自由选择'],
        picture: '../../static/images/product/ejSiNo/01.png',
        100423: {
          scheme: 'A款',
          price: '50',
          promotionExpenses: '8%',
        },
        100427: {
          scheme: 'B款',
          price: '53',
          promotionExpenses: '13%',
        },
        100428: {
          scheme: 'C款',
          price: '57',
          promotionExpenses: '17%',
        }
      },
      //-- 上海平安 - 平安团e宝雇主普通版
      '平安团e宝雇主普通版': {
        presentation: ['承保高空作业', '方案扩展6大保障', '1-5类职业可投', '最高承保保额100万'],
        picture: '../../static/images/product/ejSiNo/01.png',
        100425: {
          scheme: 'A款',
          price: '82',
          promotionExpenses: '12%',
        }
      },
    },
    3: {
      //-- 国寿财 - 关税险
      '关税保证保险': {
        presentation: ['高效率', '低成本', '3-5类职业10人起投', '简手续', '查询方便'],
        picture: '../../static/images/about/insurance-2.png',
        100409: {
          scheme: '',
          price: '',
          promotionExpenses: '',
        },
      },
    },
    4: {
      //-- 泰康 - 车险
      '泰康车险': {
        presentation: [''],
        picture: '../../static/images/about/autoInsurance/logo.png',
        100464: {
          scheme: '',
          price: '',
          promotionExpenses: '',
        },
      },
    },
    5: {
      //-- 泰康 - 车险
      '现代财产保险（中国）有限公司网络交易平台买家应付款保证保险': {
        presentation: [''],
        picture: '../../static/images/about/insurance-3.png',
        '111': {
          scheme: '',
          price: '',
          promotionExpenses: '',
        },
      },
    },
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/product/productList.js
// module id = mEwH
// module chunks = 0